import React from "react";
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { Table } from "react-bootstrap";

import Paper from "@mui/material/Paper";

type Props = {
  data: any;
  totalCount: number;
};

const WinLossTable = ({ data, totalCount }: Props) => {
  function createData(name: string, value: number, percentage: number) {
    return { name, value, percentage };
  }
  const rows: { name: string; value: number; percentage: number }[] = [];

  for (let key in data) {
    let percent: number = 0;

    if (totalCount !== 0 && data[key].value !== 0) {
      percent = Math.round((data[key].value / totalCount) * 100);
    } else {
      percent = 0;
    }

    rows.push(createData(data[key].name, data[key].value, percent));
  }

  return (
    <TableContainer component={Paper} sx={{ maxHeight: "240px", mt: 1 }}>
      <Table aria-label="simple table" style={{ marginBottom: 0 }}>
        <TableHead sx={{ backgroundColor: "#348fea" }}>
          <TableRow>
            <TableCell sx={{ color: "white" }}>Status </TableCell>
            <TableCell sx={{ color: "white" }}>Value (INR Cr)</TableCell>
            <TableCell sx={{ color: "white" }}>% of Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell align="left">{row.name}</TableCell>
              <TableCell align="left">{row.value}</TableCell>
              <TableCell align="left">{row.percentage} %</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WinLossTable;
